<template>
  <div class="index-page">
    <yx-header ref="yxHeader"></yx-header>
    <div class="content-container">

      <titleText></titleText>

      <statisticalData  :balance="balance"
                        :allJs="allJs"
                        :totalVol="totalVol"
                        :todayVol="todayVol"></statisticalData>

      <div class="trade-card">
        <!-- 交易金额输入 -->
        <div class="trade-amount">
          <div class="ta-lf">
            <div>设置自动交易总额</div>
            <input class="font2 input" type="number" placeholder="0.00" v-model="tradeAmountAll"
                   @input="calculateAmounts">
          </div>
          <div class="ta-rt">
            <div class="ta-rt-top" v-if="selectedList">
              <el-dropdown trigger="click" @command="handleCommand">
                <div class="el-dropdown-link">
                  <div class="el-dropdown-link-lf">
                    <img class="logo" :src="selectedList.imageUrl" alt="">
                    <span>{{ selectedList.symbol }}</span>
                  </div>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                  :class="{'is-active': selectedList && item.symbol === selectedList.symbol}"
                  :command="item" v-for="(item,index) in tokenPathsList" :key="index">
                    <img class="logo" :src="item.imageUrl" alt="">
                    {{ item.symbol }}
                    <i v-if="selectedList && item.symbol === selectedList.symbol" class="el-icon-check selected-icon"></i>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <!-- 交易金额输入 -->
        <div class="trade-amount">
          <div class="ta-lf">
            <div>设置单次交易金额</div>
            <input class="font2 input" type="number" placeholder="0.00" v-model="tradeAmount" @input="calculateAmounts">
          </div>
          <div class="ta-rt1">
            <div class="dc-rt" v-if="selectedList">
              <img class="logo" :src="selectedList.imageUrl" alt="">
              <span>{{ selectedList.symbol }}</span>
            </div>
            <div class="balance" v-if="selectedList">
              <span>余额: </span>
              <span class="font2">{{$formatDecimals(currentBalance)}} {{ selectedList.symbol }}</span>
                <em @click="clickMax">MAX</em>
            </div>
          </div>
        </div>
        <!-- 最优交易路径 最优交易路径 循环次数  LP池费用  Gas费用 -->
        <selectChain
            :tranNum="tranNum"
            :lpFee="lpFee"
            :gasFee="gasFee"
            :selectedCurrency="selectedCurrency"
            :defaultPath="defaultPath"
            :alphaFeePer="alphaFeePer"
            :tokenList="selectedList"
            @path-changed="updateDefaultPath"></selectChain>

        <!--回款金额  Alpha 有效交易金额  预计获取 Alpha 积分-->
        <returned :returnedAmount="returnedAmount" :alphaAmount="alphaAmount" :alphaPoints="alphaPoints" :selectedList="selectedList"></returned>

        <!-- 点击查看更多 弹出弹窗显示ui -->
        <div class="transaction-summary" @click="showTransactionDetails = true">
          <span class="summary-title">今日交易详情</span>
          <i class="el-icon-arrow-right"></i>
        </div>

        <!-- 交易按钮 -->
        <div class="ty-button" style="margin-top: 16px" @click="clickCreateTxs">{{accountInfo?'交易':'链接钱包'}}</div>

        <advantage></advantage>

      </div>
    </div>
    <!-- 这个组件关闭弹窗 -->
    <sign-transaction
        :show="showTx"
        :create-info="createInfo"
        :tradeAmount="tradeAmount"
        :selectedList="selectedList"
        :defaultPath="defaultPath"
        :defaultBalance="defaultBalance"
        :tranNum="tranNum"
        :show.sync="showTx"
        :balance="balance"
        :todayVol="todayVol"
        :allJs="allJs"
        :todayTradeList="todayTradeList"
        @transaction-sent="handleTransactionSent"
        @transaction-signed="handleTransactionSigned"
        @transaction-error="handleTransactionError"
        @update:tradeAmount="val => tradeAmount = val"
    ></sign-transaction>

    <!-- 交易详情组件 -->
    <transaction-details :show="showTransactionDetails" :show.sync="showTransactionDetails"></transaction-details>
  </div>
</template>

<script>
import yxHeader from './pageComponents/yx_header'
import titleText from './pageComponents/title'
import statisticalData from './pageComponents/statistical_data'
import advantage from './pageComponents/advantage'
import returned from './pageComponents/returned'
import selectChain from './pageComponents/select_chain'
import SignTransaction from './pageComponents/sign_transaction'
import TransactionDetails from './pageComponents/transaction_details'
import {mapState} from "vuex";
import Decimal from 'decimal.js'
import {$formatDecimals} from "../../../util/context";

export default {
  name: 'index',
  components: {
    yxHeader,
    titleText,
    statisticalData,
    advantage,
    returned,
    selectChain,
    SignTransaction,
    TransactionDetails
  },
  data() {
    this.num = {
      min: 1,
      max: 50,
    };
    return {
      balance:null, //gas余额
      todayVol:null, //交易额
      totalVol:null, //交易额
      allJs:0,//积分
      todayTradeList:[], //交易列表
      showTransactionDetails: false,
      tradeAmountAll: '', // 交易总金额
      tradeAmount: '', // 单次交易金额

      tranNum: 0,// 循环次数 公式：tradeAmountAll /  tradeAmount
      lpFee: '0',//LP池费用    公式: tradeAmount * 0.0001
      gasFee: '0',//gas费用   公式: tradeAmount * (alphaFeePer / 100)
      returnedAmount: '0',//回款金额   公式:  tradeAmount - (lpFee * 2) - (gasFee * 2)

      alphaAmount: '0',
      alphaPoints: '0', //预计获取 Alpha 积分 公式: 2的N次方  举例：1024 = 10分(2的10次方)  2048 11 积分 1024-2048之间 也是10积分

      showTx: false,//交易签名
      showChain: false,//链
      popupPoster: false,
      isExpanded: false,
      selectedCurrency: null,
      selectedList: null,
      defaultPath: null,
      selectedItem: null,
      price: 12,
      alphaFeeOpen: false, //是否显示免费
      alphaFeePer: 0, //比例
      createInfo: null, //创建交易
      defaultBalance:0,


      tokenPathsList: [],
      activeStep: 0, // 当前处于第几步，0 开始
      stepsList: ['买入', '卖出'],
    };
  },
  computed: {
    ...mapState([
      "accountInfo",
      "USDTBalance",
      "WBNBBalance",
      "isUser",
    ]),
    // 添加当前余额计算属性
    currentBalance() {
      const vm = this
      if (vm.selectedCurrency === 'USDT') {
        return vm.USDTBalance;
      } else if (vm.selectedCurrency === 'WBNB') {
        return vm.WBNBBalance;
      }
      return '0';
    }
  },
  watch: {
    selectedCurrency: {
      handler() {
        this.tradeAmount = this.currentBalance;
        this.calculateAmounts();
      }
    },
    USDTBalance: {
      handler(newVal) {
        if (this.selectedCurrency === 'USDT') {
          this.tradeAmount = newVal;
          this.calculateAmounts();
        }
      }
    },
    WBNBBalance: {
      handler(newVal) {
        if (this.selectedCurrency === 'WBNB') {
          this.tradeAmount = newVal;
          this.calculateAmounts();
        }
      }
    },
    showTx: {
      handler() {
        const vm = this
        if (vm.showTx) {
          clearInterval(vm.interCalcUpgradeLockedToken)
          vm.interCalcUpgradeLockedToken = setInterval(async() => {
            await vm.getTrade()
          }, 10000);
        }else{
          clearInterval(vm.interCalcUpgradeLockedToken)
        }
      }
    },
    'isUser': {
      async handler() {
        const vm = this
        if (vm.isUser) {
          vm.getTrade()
        }
      },
      immediate: true,
    },
  },
  created() {
    const vm = this
    vm.getTokenPaths()
  },
  // 在 mounted 钩子中添加以下代码
  mounted() {
    const vm = this;
    const contentContainer = document.querySelector('.content-container');
    const yxHeader = document.querySelector('.header'); // yx-header 组件中的 header 类

    if (contentContainer && yxHeader) {
      contentContainer.addEventListener('scroll', function() {
        if (contentContainer.scrollTop > 0) {
          yxHeader.classList.add('with-border');
        } else {
          yxHeader.classList.remove('with-border');
        }
      });
    }
  },
  methods: {
    // 点击max
    clickMax() {
      const vm = this;
      if (vm.selectedCurrency == 'USDT') {
        vm.tradeAmount = vm.USDTBalance
      } else {
        vm.tradeAmount = vm.WBNBBalance
      }
      vm.calculateAmounts();
    },
    confirmSelection() {
      const vm = this;
      vm.showChain = false
      vm.defaultPath = vm.selectedItem
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    calculateAmounts() {
      const vm = this
      if(vm.tradeAmountAll){
        vm.tradeAmountAll = parseInt(vm.tradeAmountAll)
      }
      if(vm.tradeAmount){
        vm.tradeAmount = $formatDecimals(vm.tradeAmount,2)
      }

      // 计算循环次数 - 向上取整
      if (this.tradeAmountAll && this.tradeAmount && parseFloat(this.tradeAmount) > 0) {
        // 当总金额小于单次金额时，至少执行1次
        if (new Decimal(this.tradeAmountAll).lessThan(this.tradeAmount)) {
          this.tranNum = 1;
        } else {
          this.tranNum = Math.ceil(new Decimal(this.tradeAmountAll).div(this.tradeAmount));
        }
      } else {
        this.tranNum = 0;
      }

      if (vm.tradeAmount) {
        const tradeAmount = new Decimal(vm.tradeAmount);

        // LP池费用计算：tradeAmount * 0.0001
        vm.lpFee = tradeAmount.mul(0.0001).toString();

        // gas费用计算：tradeAmount * (alphaFeePer / 100)
        const feeRate = new Decimal(vm.alphaFeePer).div(100);
        vm.gasFee = tradeAmount.mul(feeRate).toString();

        // 回款金额计算：tradeAmount - (lpFee * 2) - (gasFee * 2)
        vm.returnedAmount = tradeAmount.sub(new Decimal(vm.lpFee).mul(2)).sub(new Decimal(vm.gasFee).mul(2)).toString();

        vm.alphaAmount = tradeAmount.mul(vm.selectedList.price).toString();

        // 计算预计获取 Alpha 积分
        const alphaAmountDec = new Decimal(vm.alphaAmount);
        let points = 0;
        while (new Decimal(2).pow(points).lt(alphaAmountDec)) {
          points++;
        }
        if (new Decimal(2).pow(points).gt(alphaAmountDec)) {
          points--;
        }
        vm.alphaPoints = points.toString();
      } else {
        vm.lpFee = '0';
        vm.gasFee = '0';
        vm.returnedAmount = '0';
        vm.alphaAmount = '0';
        vm.alphaPoints = '0';
      }
    },
    calcAlpha() {
      const vm = this;
      const amount = new Decimal(vm.tradeAmount || 0);
      let alphaAmount = new Decimal(0);

      alphaAmount = amount.mul(this.selectedList.price || 0);

      vm.alphaAmount = alphaAmount.toFixed(6);

      // 计算 Alpha 积分
      let points = 0;
      const base = new Decimal(2);
      while (base.pow(points).lt(alphaAmount)) {
        points++;
      }
      if (base.pow(points).gt(alphaAmount)) {
        points--;
      }
      vm.alphaPoints = points;
    },
    updateDefaultPath(path) {
      const vm = this
      vm.defaultPath = path;
    },
    // 获取交易路径列表
    getTokenPaths() {
      const vm = this
      vm.$axios.defaults.withCredentials = false;
      vm.$axios.get('/alpha/paths')
          .then(function (response) {
            const {success, msg, data} = response.data
            if (success) {
              vm.alphaFeeOpen = data.alphaFeeOpen

              vm.alphaFeePer = parseFloat(data.alphaFeePer.replace('%', ''));


              vm.tokenPathsList = data.tokenPathVos;

              vm.selectedList = data.tokenPathVos[0];

              vm.selectedCurrency = data.tokenPathVos[0].symbol

              vm.defaultPath = data.tokenPathVos[0].pathTokens[0]

              // 设置 tradeAmount 为当前余额
              if (vm.selectedCurrency === 'USDT') {
                vm.tradeAmount = vm.USDTBalance;
              } else if (vm.selectedCurrency === 'WBNB') {
                vm.tradeAmount = vm.WBNBBalance;
              }

               // 计算相关金额
                vm.calculateAmounts();
            } else {
              vm.$message.error(msg || '请求数据失败')
            }
          }).catch(error => {
        console.error(error)
        // vm.$toast({
        //   message: error || '错误~',
        //   position: 'top',
        // });
      })
    },

    jsJs(num){
      // 计算预计获取 Alpha 积分
      const alphaAmountDec = num;
      let points = 0;
      while (new Decimal(2).pow(points).lt(alphaAmountDec)) {
        points++;
      }
      if (new Decimal(2).pow(points).gt(alphaAmountDec)) {
        points--;
      }
      if(points <0){
        points = 0
      }
      return points
    },
    // 获取 交易信息
    getTrade() {
      const vm = this
      vm.$axios.defaults.withCredentials = false;
      vm.$axios.get(`/alpha/trade/data/${vm.accountInfo}`)
          .then(function (response) {
            const {success, msg, data} = response.data
            if (success) {
              vm.balance = data.balance
              vm.todayVol = data.todayVol;
              vm.totalVol = data.totalVol;
              vm.todayTradeList = data.todayTradeList;
              vm.allJs = vm.jsJs(data.todayVol)
            } else {
              vm.$message.error(msg || '请求数据失败')
            }
          }).catch(error => {
        console.error(error)
        vm.$toast({
          message: error || '错误~',
          position: 'top',
        });
      })
    },
    // 点击交易
    async clickCreateTxs() {
      const vm = this
      if (!vm.accountInfo) {
        vm.$refs.yxHeader.connectWalletInit();
        return;
      }
      // vm.showTx = true
      await window.threeKingdoms.init();
      console.log('请求参数',vm.defaultPath.address, vm.accountInfo)
      vm.defaultBalance = await threeKingdoms.getTokenBalance(vm.defaultPath.address, vm.accountInfo);
      console.log('vm.defaultBalance111',vm.defaultBalance,vm.currentBalance)
      // 检查交易金额是否已填写
      if (!vm.tradeAmountAll || !vm.tradeAmount) {
        vm.$toast({
          message: '请设置自动交易总额和单次交易金额',
          position: 'top',
        });
      } else if (vm.tradeAmount <= 0) {
        vm.$toast({
          message: '交易金额需大于0',
          position: 'top',
        });
      } else if (parseFloat(vm.defaultBalance) <= 0 && parseFloat(vm.currentBalance) <= 0) {
        console.log('vm.defaultBalance',vm.defaultBalance,vm.currentBalance)
        vm.$toast({
          message: '余额不足',
          position: 'top',
        });
      } else{
        vm.showTx = true
        // vm.tradeAmountAll = '', // 交易总金额
        // vm.tradeAmount = '' // 交易总金额
      }
    },
    handleCommand(command) {
      const vm = this
      vm.selectedCurrency = command.symbol;
      vm.selectedList = command;
      vm.defaultPath = command.pathTokens[0]

       // 设置 tradeAmount 为当前余额
      vm.tradeAmount = vm.currentBalance;
      vm.calculateAmounts(); // 币种切换时调用计算方法
    },

    // 处理交易发送成功
    handleTransactionSent(txHash) {
      console.log('交易发送成功:', txHash);
      // 可以在这里添加后续处理逻辑
    },

    // 处理交易签名成功
    handleTransactionSigned(txHash) {
      console.log('交易签名成功:', txHash);
      // 可以在这里添加后续处理逻辑
    },

    // 处理交易错误
    handleTransactionError(error) {
      console.error('交易处理错误:', error);
      // 可以在这里添加错误处理逻辑
    },

  },
}
</script>

<style lang="scss" scoped>
.index-page {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.content-container {
  padding: 5px 16px 0 16px;
  width: 100%;
  box-sizing: border-box;
  flex: 1;
  overflow-y: auto;
  max-width: 520px;
  margin: 0 auto;
  background-color: #fff;
}

@media screen and (min-width: 520px) {
  .index-page{
    background-image: url("~@/assets/imgs/bg.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
  }
  .content-container{
    box-shadow: 0px 8px 60px 0px #0000000F;
  }
}

</style>